module.exports = __webpack_public_path__ + "assets/images/5d3980723864d01d61e7363425f16cc2.png";